module.exports = __webpack_public_path__ + "img/icon-jcfw.a4cabbd1.png";